import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ReCheckIcon from './Frame 45111977.png';
import { eocTestId } from './test-ids';

type Props = {
  handleCancel: () => void;
  handleContinue: () => void;
};

const RecheckCloseEoc = (props: Props) => {
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data
  );
  const canOverride = permissionData?.currentPermissions?.includes(
    'Override ReCheck for Discharge'
  );
  const [agree, setAgree] = useState(false);

  return (
    <Box
      p={3}
      data-testid={eocTestId('caseload-dialog')}
    >
      <>
        <DialogContent>
          <Box sx={{ display: 'flex' }}>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <img
                  alt="recheck"
                  src={ReCheckIcon}
                />
                <Typography variant="h5"> | Patient Still on Caseload</Typography>
              </Box>
            </Box>
          </Box>

          <Stack>
            <Typography
              variant="body1"
              fontWeight="600"
              flexWrap="wrap"
            >
              Please discharge the patient from all active disciplines (PT, OT, and SLP) before
              closing the Episode of Care
            </Typography>
          </Stack>

          {canOverride && (
            <Stack
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              mt={3}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agree}
                    inputProps={
                      {
                        'data-testid': eocTestId('caseload-acknowledge'),
                      } as React.InputHTMLAttributes<HTMLInputElement>
                    }
                    onChange={(e) => setAgree(e.target.checked)}
                  />
                }
                label={
                  <Typography
                    variant="body1"
                    fontWeight="600"
                    flexWrap="wrap"
                  >
                    I&apos;ve reviewed the alerts and approve to close the Episode of Care
                  </Typography>
                }
              />
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          {canOverride ? (
            <>
              <Button
                variant="text"
                data-testid={eocTestId('caseload-cancel')}
                onClick={props.handleCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                data-testid={eocTestId('caseload-continue')}
                onClick={props.handleContinue}
                disabled={!agree}
              >
                Continue
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              data-testid={eocTestId('caseload-acknowledged')}
              onClick={props.handleCancel}
            >
              Got It
            </Button>
          )}
        </DialogActions>
      </>
    </Box>
  );
};

export default RecheckCloseEoc;
